<template>
  <div>
    <div class="search bb">
      <div class="flex-box flex-v-c status">
        <div class="flex1 statusBtn" :class="{focus:focusNum==0}" @click="changLevel('')">全部</div>
        <div class="flex1 statusBtn" :class="{focus:focusNum==1}" @click="changLevel(1)">下滑代理</div>
        <div class="flex1 statusBtn" :class="{focus:focusNum==2}" @click="changLevel(2)">流失代理</div>
        <div class="flex1 dirBtn flex-box flex-hv-c" @click="sortSwitch">
          <select id="sel" class="selectDistrict" @change="select" v-model="sendData.district">
            <option value selected>全部</option>
            <option
              :value="item.value"
              :key="item.value"
              v-for="(item,index) in districtList"
            >{{item.label}}</option>
          </select>
          <!-- <i class="iconfont" :class="{iconXiajiantou:!sortListShow,iconShangjiantou:sortListShow}"></i> -->
          <i class="iconfont iconXiajiantou"></i>
        </div>
      </div>
      <div class="flex-box flex-v-c br">
        <div class="flex1 flex-box flex-v-c">
          <input
            class="searchInput"
            type="text"
            v-model="sendData.keyword"
            placeholder="代理/游戏ID/昵称"
          />
          <div class="closeBtn" v-show="sendData.keyword" @click="clear"></div>
        </div>
        <div class="flex-box flex-v-c">
          <div class="flex1 button searchBtn" @click="search">
            搜索
            <i class="iconfont icon-search"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="bb" style="background:#f1f1f1; padding:6px 0;">
      <!-- <div class="tipText">此页面显示团队开房数昨天与前天对比下降50%及以上的代理，点击可查看代理近7天、15天、30天的开房和奖励数据趋势</div> -->
      <div class="tipText2">预警级别说明：</div> 
      <div class="tipText2">轻度下滑：下降率在20%-39%，则显示为轻度下滑</div> 
      <div class="tipText2">重度下滑：下降率在40%-70%之间，则显示为重度下滑</div> 
      <div class="tipText2">预流失：下降率大于70%小于100%，则显示为预流失</div> 
      <div class="tipText2">重点流失：近10天平均场次为0，则显示为重点流失</div> 
      <div class="tipText2">新流失：昨日场次为0，则显示为新流失</div> 
    </div>
    <Cloadmore @loadBottom="loadBottom" @loadTop="loadTop" ref="listTopic">
      <ul v-if="list.length>0" v-cloak>
        <li v-for="(item,index) in list" @click="details(item.memberId)">
          <div class="flex-box flex-v-c warning">
            <div class="flex-1 flex-box flex-item-box">
              <p class="flex-item">代理ID: {{item.memberId }}</p>
              <p class="flex-item">预警级别: <span class="warning-sp">{{item.warnLevel}}</span></p>
              <p class="flex-item">昵称: {{item.nickname }}</p>
              <p class="flex-item">下降率: <span class="warning-sp">{{item.rate}}</span></p>
              <p class="flex-item">绑定人数: {{item.bindCount }}</p>
              <p class="flex-item">昨日场次: {{item.yesterdayGame }}</p>
              <p class="flex-item">等级: {{item.level }}</p>
              <p class="flex-item">近10天平均场次: {{item.avg10Game }}</p>
              <p class="flex-item">转正时间: {{item.officialTime | formatDate }}</p>
              <p class="flex-item">近30天平均场次: {{item.avg30Game }}</p>
            </div>
            <div class="img-box"><p style="text-align:center;padding-bottom:5px;">代理头像</p><img class="avatar-img" :src="item.avatar" alt=""></div>
            <i class="iconfont icon-more more"></i>
          </div>
        </li>
      </ul>
      <div v-else class="nullData">暂无数据~</div>
    </Cloadmore>
    <transition name="trans">
      <detail :memberId="detailId" class="detail" v-if="detailShow" @ctrDetails="ctrDetails(false)"></detail>
    </transition>
  </div>
</template>
<!--javascript-->
<script>
import Cloadmore from '../loadmore/loadmore.vue'
import detail from '../memberWarn/detail.vue'
export default {
  components: { Cloadmore, detail },
  data: function () {
    return {
      loader: false,
      list: [],
      districtList: this.$store.state.envData[localStorage.env].district,
      sortListShow: false,//控制显示隐藏
      sendData: {
        index: 1,
        pageNum: 10,
        type: '',
        keyword: '',
        district: ''
      },
      detailId: '',
      detailShow: false,
      focusNum: 0
    }
  },
  methods: {
    getData(params) {
      let that = this;
      that.$http.get('/member/warnMemberList', {
        params: that.sendData
      }).then(function (res) {
        if (res.code == 0) {
          that.loader = true;
          that.dataLength = res.data.list.length;
          if (that.dataLength > 0) {
            for (let i = 0; i < that.dataLength; i++) {
              that.list.push(res.data.list[i])
            }
            if (params == 'getNewData') {//下拉 刷新 或者 搜索 时  获取新数据 避免使用清空数组造成的闪屏
              for (let i = 0; i < that.dataLength; i++) { //新数据有多少条
                that.list[i] = res.data.list[i]
              }
              that.list.length = that.dataLength;//截取数组长度
            }
          } else {
            if(params == 'getNewData'){  // 切换的时候没有数据，list置为空
              that.list = [];
            }
            that.$refs.listTopic.setAllLoaded(true);
            that.$toast({
              message: '没有更多数据', position: 'bottom'
            })
          }
        } else {
          that.$toast(res.message)
        }
      })
    },
    loadTop() {
      let that = this;
      that.sendData.index = 1;
      that.sendData.pageNum = 10;
      that.sendData.keyword = '';
      that.getData('getNewData')
      setTimeout(function () {
        that.$refs.listTopic.onTopLoaded()
      }, 1000);
      that.$refs.listTopic.setAllLoaded(false)
    },
    loadBottom() {
      let that = this;
      if (!that.loader) {
        return
      }
      that.sendData.index += 1;
      setTimeout(function () {
        that.$refs.listTopic.onBottomLoaded();
      }, 1000);
      that.getData()
    },
    search() {
      if (!this.sendData.keyword) {
        this.$toast('请输入游戏ID')
        return
      }
      this.getData('getNewData')
    },
    clear() {
      this.sendData.keyword = '';
    },
    sort(params) {
      this.sendData.order = params;
      this.sendData.index = 1;
      this.sendData.id = '';
      this.memberId = '';
      this.getData('getNewData')
      this.sortSwitch()
    },
    sortSwitch() {
      this.sortListShow = !this.sortListShow
    },
    ctrDetails(params) {
      this.detailShow = params;
    },
    details(memberId) {

      this.detailId = memberId;
      this.ctrDetails(true)
    },
    changLevel(type) {
      let that = this;
      that.focusNum = type
      if (type == '') {
        that.sendData.type = ''
      } else if (type == 1) {
        that.sendData.type = 1
      } else if (type == 2) {
        that.sendData.type = 2
      }
      that.getData('getNewData')
    },
    select() {
      this.getData('getNewData')
    }
  },
  mounted: function () {
    this.getData()
  },
  created: function () {
    console.log(this.list)
  }
}
</script>
<!--styleSheet-->
<style scoped lang="less" rel="stylesheet/less">
* {
  margin: 0;
  padding: 0;
}
.flex-item-box{
  justify-content : space-between;
  flex-wrap : wrap;
}
.flex-item{
  width:50%;
  height:20px;
  line-height:20px;
}
.img-box{
  width:150px;
}
.img-box .avatar-img{
  width:100%;
}
.warning-sp{
  color:red;
}
.closeBtn {
  position: relative;
  width: 1rem;
  height: 0.6rem;
}
.statusBtn {
  margin: 4px;
  height: 0.6rem;
  line-height: 0.6rem;
  min-width: 1.46rem;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid rgb(204, 204, 204);
}

.button {
  color: #fff;
  margin: 4px;
  height: 0.6rem;
  line-height: 0.6rem;
  /*min-width: 0.8rem;*/
  border-radius: 4px;
  background: #3d435f;
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dirBtn {
  margin: 4px;
  height: 0.6rem;
  line-height: 0.6rem;
  min-width: 1.46rem;
  padding: 4px 4px 4px 0;
  color: #000;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.searchInput {
  margin: 4px;
  height: 0.6rem;
  min-width: 4.7rem;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
}

.selectBtn {
  /*min-width: 65px;*/
  color: #fff;
  margin: 4px;
  height: 0.5rem;
  line-height: 0.5rem;
  border-radius: 4px;
  background: #3d435f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.closeBtn {
  height: 100%;
}

.tipText {
  font-size: 10px;
  padding: 10px;
  color: orangered;
}
.tipText2{
  font-size: 10px;
  padding: 0 10px;
}

.sort .iconfont {
  font-size: 0.1rem;
  margin-top: 2px;
  margin-left: 3px;
}
ul {
  li {
    line-height: 1.5;
    padding: 10px;
    position: relative;
    min-height: 1.2rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
}

.selectDistrict {
  border: none;
  width: 100%;
  padding: 0 0 0 15px;
  outline: none;
}
.iconXiajiantou,
.iconShangjiantou {
  font-size: 0.2rem;
}

.warning {
  margin-bottom: 10px;
  padding-right:30px;
}

.amColor {
  color: orangered;
}

.focus {
  background: #3d435f;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/memberWarn/index.vue